import { createSlice } from '@reduxjs/toolkit';
import { resetLineMarker, ResetLineMarkerResponse } from '../line-marker-config/services/LineMarkerService';

// Extended state interface to support loading and error
const initialState = {
  data: null as ResetLineMarkerResponse | null,
  loading: false,
  error: undefined,
};

const LineMarkerReset = createSlice({
  name: 'asset',
  initialState,
  reducers: {
    setLineMarkerInitialState: (state) => {
      state.data = null;
      state.error = undefined;
      state.loading = false;
    },
  },
  extraReducers: (builder) => {
    builder;
    builder
      .addCase(resetLineMarker.pending, (state) => {
        state.loading = true;
      })
      .addCase(resetLineMarker.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(resetLineMarker.rejected, (state, action) => {
        state.loading = false;
        console.log('action.error.message::', action.error.message);
      });
  },
});

export const { setLineMarkerInitialState } = LineMarkerReset.actions;

export default LineMarkerReset.reducer;
